var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3252 10.1333C10.9252 9.41659 9.1085 8.83325 7.00016 8.83325C4.89183 8.83325 3.07516 9.41659 1.67516 10.1333C0.84183 10.5583 0.333496 11.4166 0.333496 12.3499V14.6666H13.6668V12.3499C13.6668 11.4166 13.1585 10.5583 12.3252 10.1333ZM12.0002 12.9999H2.00016V12.3499C2.00016 12.0333 2.16683 11.7499 2.4335 11.6166C3.42516 11.1083 5.02516 10.4999 7.00016 10.4999C8.97516 10.4999 10.5752 11.1083 11.5668 11.6166C11.8335 11.7499 12.0002 12.0333 12.0002 12.3499V12.9999Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 8C8.84199 8 10.3337 6.50833 10.3337 4.66667C10.3337 3.525 10.3337 1.75 10.3337 1.75C10.3337 1.05833 9.77533 0.5 9.08366 0.5C8.65033 0.5 8.26699 0.725 8.04199 1.05833C7.81699 0.725 7.43366 0.5 7.00033 0.5C6.56699 0.5 6.18366 0.725 5.95866 1.05833C5.73366 0.725 5.35033 0.5 4.91699 0.5C4.22533 0.5 3.66699 1.05833 3.66699 1.75C3.66699 1.75 3.66699 3.51667 3.66699 4.66667C3.66699 6.50833 5.15866 8 7.00033 8ZM5.33366 2.58333H8.66699V4.66667C8.66699 5.58333 7.91699 6.33333 7.00033 6.33333C6.08366 6.33333 5.33366 5.58333 5.33366 4.66667V2.58333Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserIcon);
export default __webpack_public_path__ + "static/media/profile_user_icon.e4c1c9cc031b51ca635c5aaeb663f77f.svg";
export { ForwardRef as ReactComponent };